import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "../icons/icons";

import { useTranslation } from "react-i18next";

import styles from "./ErrorPlaceholder.module.scss";

type Props = {
  desc: string;
  title1: string;
  title2: string;
  basicUrl?: string;
};

const ErrorPlaceholder: React.FC<Props> = ({ desc, title1, title2, basicUrl }) => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <div className={styles.page404}>
      <div className={styles.container}>
        <div className={styles.circle}>
          <div className={styles.title1}>{title1}</div>
          <div className={styles.title2}>{title2}</div>
          <div className={styles.desc}>{desc}</div>
          <Link to={{ pathname: basicUrl || "/", search: location.search }} className={styles.link}>
            <button type="button" className={styles.btn}>
              <ArrowRight />
              {t("Homepage")}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ErrorPlaceholder);
